import type { IconName } from '@/types';

export enum StatusStateMap {
  Success = 'success',
  Warning = 'warning',
  Notice = 'notice',
  Error = 'error',
}

export const statusToCssClassesMap: Record<StatusStateMap, string> = {
  [StatusStateMap.Success]: 'text-(--color-green)',
  [StatusStateMap.Warning]: 'text-(--color-orange)',
  [StatusStateMap.Notice]: 'text-(--color-yellow)',
  [StatusStateMap.Error]: 'text-(--color-red)',
};

export const statusToIconMap: Record<StatusStateMap, IconName> = {
  [StatusStateMap.Success]: 'check-round',
  [StatusStateMap.Warning]: 'exclamation-round',
  [StatusStateMap.Notice]: 'exclamation-round-border',
  [StatusStateMap.Error]: 'exclamation-round',
};
